import Link from 'next/link';
import { useRouter } from 'next/router';

const Navigation = () => {

  const path = useRouter()

  const getVideoSource = () => {
    if (path.asPath === '/') {
      return 'https://res.cloudinary.com/dxrtssxet/video/upload/v1682176436/Athena%20Mercury/Athena%20Mercury%20-%20Videos/JUMPSUIT_NEW_SIZE_compressed_video_20230422_150926_cqisbz.mp4';
    } else if (path.asPath === '/portfolio') {
      return 'https://res.cloudinary.com/dxrtssxet/video/upload/v1682176433/Athena%20Mercury/Athena%20Mercury%20-%20Videos/GLOVE_NO_1_NEW_SIZE_compressed_video_20230422_153307_sqkiml.mp4';
    } else if (path.asPath === '/collection') {
      return 'https://res.cloudinary.com/dxrtssxet/video/upload/v1682176435/Athena%20Mercury/Athena%20Mercury%20-%20Videos/DRESS_NEW_SIZE_compressed_video_20230422_143302_qj84wp.mp4';
    } else if (path.asPath === '/purpose') {
      return 'https://res.cloudinary.com/dxrtssxet/video/upload/v1682777631/Athena%20Mercury/Athena%20Mercury%20-%20Videos/sewing_4mb_compressed_video_20230428_164053_zvom1y.mp4';
    } else if (path.asPath === '/contact') {
      return 'https://res.cloudinary.com/dxrtssxet/video/upload/v1682775688/Athena%20Mercury/Athena%20Mercury%20-%20Videos/2nd_glove_2.5mb_compressed_video_20230428_163446_gb3bup.mp4';
    }
  };

  const videoSource = getVideoSource();

  return (
    <div>
      <section className='flex sticky w-screen top-0 inset-x-0 text-white'>
        <div className='sticky desktop:-mt-32 xlarge:-mt-44'>
          <video className='' id='video'muted autoPlay={true} loop playsInline={true}><source src={videoSource}/></video>
        </div>
        <nav className='absolute pt-5 pl-3 desktop:pl-4 text-[8px] navSM:text-[11px] navBM:text-[13px] navM:text-[17px] tablet:text-xl laptop:text-3xl'>
          <ul className='space-x-3 tablet:space-x-10'>
            <Link className="hover:text-hover" href='/'>Home</Link>
            <Link className="hover:text-hover" href='/portfolio'>Portfolio</Link>
            <Link className="hover:text-hover" href='/collection'>Collection</Link>
            <Link className="hover:text-hover" href='/purpose'>Purpose</Link>
            <Link className="hover:text-hover" href='/contact'>Contact</Link>
          </ul>
        </nav>
        <div className='flex flex-col absolute mt-10 laptop:mt-12'>
          <div className='ml-3 font-bold desktop:ml-5 text-4xl mobile:text-[40px] tablet:text-[85px] desktop:text-9xl'>{(path.asPath === '/') ? 'ATHENA MERCURY' : path.asPath.slice(1,).toUpperCase()}</div>
        </div>
      </section>
    </div>
  )
}

export default Navigation